import { usePlanShortStayParams as useShortStayParams } from "@/components/features/items/edit/plan/_shared/ui/components/stay-length/short-stay-params/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanShortStayParams = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { shortStayParams } = viewModel;

	return useShortStayParams({ onSetViewModel, shortStayParams });
};
